import styled from 'styled-components';
import sprites from '../../assets/svg/sprites.svg';

export const CTAWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-around;

  @media (max-width: 767.98px) {
    flex: 0 0 100%;
    max-width: 100%;

    a,
    button {
      max-width: 300px;
      margin-right: auto !important;
      margin-left: auto !important;

      @media (max-width: 767.98px) {
        width: 100%;
      }
    }

    .cta_btn_cc {
      @media (max-width: 575.98px) {
        width: ${({ dir }) => (dir === 'rtl' ? '100%' : '100%')};
      }
    }

    .social_link {
      margin: 0 5px !important;
    }
  }

  @media (max-width: 576px) {
    padding: 0 0 16px;
    width: auto;
    text-align: center;
    max-width: 100%;
  }

  &.footer_cta_wrapper {
    .chatwithus {
      svg {
        width: 18px;
        height: 18px;
        fill: #fff;
      }
    }
  }

  @media (max-width: 1199px) and (min-width: 992px) {
    width: 40%;
  }

  button,
  a {
    .has-phone {
      text-align: right;
      direction: ltr;
      display: inline-block;
    }

    &:nth-child(2) {
      margin: 1rem 0;
      position: relative;
      text-indent: 25px;
      display: flex;
      justify-content: center;

      /* &:before {
                content: '';
                background-image: url(${sprites}#chati);
                background-repeat: no-repeat;
                width: 18px;
                height: 18px;
                position: relative;
                left: 0;
                right: 75px;
                margin: 0;
            } */
    }
  }
`;
